export function clampPage(page: number, totalPages: number): number {
  if (!Number.isFinite(page)) return 1;
  return Math.min(totalPages, Math.max(1, Math.trunc(page)));
}

export function pageFromHash(hash: string, totalPages: number): number {
  const normalizedHash = hash.startsWith("#") ? hash.slice(1) : hash;
  const rawPage = new URLSearchParams(normalizedHash).get("page");
  if (rawPage === null || !/^\d+$/.test(rawPage)) return 1;

  return clampPage(Number.parseInt(rawPage, 10), totalPages);
}

export function pageHash(page: number, totalPages: number): string {
  return `#page=${clampPage(page, totalPages)}`;
}

export function readerUrl(
  pathname: string,
  search: string,
  catalogId: string,
  page: number,
  totalPages: number,
): string {
  const parameters = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  parameters.set("catalog", catalogId);
  const query = parameters.toString();
  return `${pathname}${query ? `?${query}` : ""}${pageHash(page, totalPages)}`;
}

export function formatPage(page: number, totalPages: number): string {
  const digits = Math.max(2, String(totalPages).length);
  return `${String(clampPage(page, totalPages)).padStart(digits, "0")} / ${String(totalPages).padStart(digits, "0")}`;
}
